module.exports = __webpack_public_path__ + "media/images/icons/public_questions-ec3b25f140befe23f75b419b0216dd38.svg";